module.exports = "/static/media/voicemail.9993bb66.svg";